module.exports = __webpack_public_path__ + "img/videowiki-cast.482399db.svg";